import { createAction } from 'redux-actions';
import { store } from 'store/createStore';
import _ from 'lodash';

import API from '../../../../../utils/api';

export const setCheckingMobileConnection = createAction(
  '@@channelAdmin/setCheckingMobileConnection',
  value => () => {
    return value;
  }
);

export const fetchChannelEvent = createAction(
  '@@channelHost/fetchChannelEvent',
  eventId => () => {
    const params = {
      populate: 'channel host game',
      query: JSON.stringify({ _id: eventId }),
    };

    return API.getChannelEvent(eventId, params).then(({ data }) => data);
  }
);

export const fetchInteractions = createAction(
  '@@channelHost/fetchInteractions',
  showClosed => () => {
    const event = _.get(store.getState(), 'channelHost.event', {});
    const query = { event: event._id };

    if (!showClosed) {
      query.active = true;
    }

    return API.getInteractions({
      select: 'name publishedAt type template active standalone',
      query: JSON.stringify(query),
      interactionEngagement: true,
    }).then(({ data }) => {
      if (data && data.docs) {
        return data.docs;
      }
    });
  }
);

export const changeChannelSocket = createAction('@@channelHost/changeChannelSocket');

export const copyToClipboard = createAction('@@channelHost/copyToClipboard');

export const fetchInteractionAnalytics = createAction(
  '@@channelHost/fetchInteractionAnalytics',
  interactionId => () =>
    API.getInteractionStatistics({
      interaction: interactionId,
    }).then(({ data }) => data)
);

export const filterOption = createAction(
  '@@channelHost/filterOption',
  (interaction, question, option) => async () => {
    const hostState = store.getState().channelHost;
    const users = _.get(
      hostState,
      `interactionAnalytics.data.${question.questionIdx}.options.${option.index}.users`,
      []
    );

    if (users) {
      return API.getUserInteractions({ users }).then(({ data }) => {
        if (data && data.docs) {
          return data.docs;
        }
      });
    }
  }
);

export const updateClientsMobileConnected = createAction(
  '@@channelHost/updateClientsMobileConnected',
  users => () => {
    return users;
  }
);

export const updateListClientsConnected = createAction(
  '@@channelAdmin/updateListClientsConnected',
  users => () =>
    API.getUserInteractions({ users }).then(({ data }) => {
      if (data && data.docs) {
        return data.docs;
      }
    })
);

export const onCloseDialogAnalytics = createAction(
  '@@channelHost/onCloseDialogAnalytics'
);

export const closeDataListView = createAction('@@channelHost/closeDataListView');

export const closeEvent = createAction(
  '@@channelHost/closeEvent',
  eventId => () => API.stopChannelEvent(eventId)
);
